import styled from 'styled-components';
import Icon from '../../Icon';

export const Root = styled.div`
  height: 100%;
`;

export const MapContainer = styled.div`
  width: 100%;
  height: 100%;
`;

export const Markers = styled.div`
  display: none;
`;

export const Marker = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  background-color: ${props => props.theme.color.white};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);

  &:after {
    position: absolute;
    bottom: -5px;
    left: calc(50% - 5px);
    width: 10px;
    height: 10px;
    background-color: ${props => props.theme.color.white};
    content: '';
    transform: rotate(45deg);
    transform-origin: center;
  }
`;

export const MarkerIcon = styled(Icon)`
  font-size: 15px;
  line-height: 30px;
`;
